export default class  BotonModal {
    constructor(boton, esApertura) {
        const modalId = boton.getAttribute("aria-controls");
        this.boton = boton;
        this.modal = document.getElementById(modalId);
        this.configurar(esApertura);
    }

    configurar(esApertura) {
        this.abrirModal = this.modalAbrirCallback();
        this.cerrarModal = this.modalCerrarCallback();
        this.boton.setAttribute("aria-haspopup", "dialog");
        this.boton.addEventListener("click", esApertura ? this.abrirModal : this.cerrarModal);
    }

    modalAbrirCallback() {
        return () => {
            this.modal.showModal();
            this.alternarExpansion();
        };
    }

    modalCerrarCallback() {
        return () => {
            this.modal.close();
            this.alternarExpansion();
        };
    }

    alternarExpansion() {
        const botonesModal = window.botonesModal.filter(botonModal => botonModal.modal === this.modal),
                expansion = this.modal.open ? "true" : "false";
        for (const botonObjeto of botonesModal) {
            botonObjeto.boton.setAttribute("aria-expanded", expansion);
        }
    }
}